import { usePage } from "@inertiajs/react";
import React, { useRef } from "react";
import { AiOutlineArrowLeft, AiOutlineArrowRight } from "react-icons/ai";

import Typography from "@/components/Typography";
import { monthSlashYearFormat } from "@/utils/dateFormater";

import MonthCard from "./EconomyMonths";
import { Button, Buttons, Container, MonthDiv, TextDiv, TextDivInfo } from "./styles";

interface AccountTotal {
  total_amount_brl: number;
}

interface PriceDetails {
  account_total?: AccountTotal;
  brp_solar_generation_details?: {
    total_payable_brp_brl?: number;
  };
  light_consumption_and_other_expenses?: {
    total_payable_light_brl?: number;
  };
}

interface EnergyExpense {
  reference_month: string;
  price_without_geedee_details: PriceDetails;
  price_with_geedee_details: PriceDetails;
}

const EconomyCard = () => {
  const slide = useRef<HTMLInputElement>(null);
  const { bills } = usePage().props;

  const MonthlyValues = (bills as EnergyExpense[]).map((bill: EnergyExpense) => {
    const monthName = bill.reference_month
      ? monthSlashYearFormat(bill.reference_month).toLocaleUpperCase()
      : "";
    const distributorValue =
      bill?.price_without_geedee_details?.account_total?.total_amount_brl || 0;
    const geedeeValue =
      bill?.price_with_geedee_details?.brp_solar_generation_details?.total_payable_brp_brl || 0;
    const lightValue =
      bill?.price_with_geedee_details?.light_consumption_and_other_expenses
        ?.total_payable_light_brl || 0;
    const discount = distributorValue - geedeeValue - lightValue;

    return {
      monthName,
      distributor_value: distributorValue,
      geedee_value: geedeeValue,
      light_value: lightValue,
      discount,
    };
  });

  const HandleLeftClick = (event: React.MouseEvent) => {
    event.preventDefault();
    if (slide && slide.current) {
      slide.current.scrollLeft -= slide.current.offsetWidth;
    }
  };

  const HandleRightClick = (event: React.MouseEvent) => {
    event.preventDefault();
    if (slide && slide.current) {
      slide.current.scrollLeft += slide.current.offsetWidth;
    }
  };

  return (
    <Container>
      <TextDiv>
        <Typography variant="h6">Descubra sua economia com a Geedee.</Typography>
        <TextDivInfo>
          <Typography variant="overline">Preço sem Energia Solar</Typography>

          <Typography variant="overline">Valor cobrado Geedee</Typography>

          <Typography variant="overline">Valor cobrado Light</Typography>

          <Typography variant="overline">Desconto</Typography>
        </TextDivInfo>
      </TextDiv>
      <MonthDiv ref={slide}>
        {MonthlyValues?.map((monthInfo, id) => (
          <MonthCard
            key={id}
            month={monthInfo.monthName}
            distributorPrice={monthInfo.distributor_value}
            price={monthInfo.geedee_value}
            lightPrice={monthInfo.light_value}
            discount={monthInfo.discount}
          />
        ))}
      </MonthDiv>
      <Buttons>
        <Button onClick={(e) => HandleLeftClick(e)}>
          <AiOutlineArrowLeft color="white" size={20} />
        </Button>
        <Button onClick={(e) => HandleRightClick(e)}>
          <AiOutlineArrowRight color="white" size={20} />
        </Button>
      </Buttons>
    </Container>
  );
};

export default EconomyCard;
